<script setup lang="ts">
import { onMounted } from "vue";
import { useTheme } from "@/composables/useTheme";
import { useUiStore } from "@/stores/ui";

// Initialize theme early so the UI matches the pre-rendered class on <html>
const { init: initTheme } = useTheme();
const ui = useUiStore();

onMounted(() => {
  initTheme();
  ui.init();
});
</script>

<template>
  <router-view />
</template>
